/* Плеер трейлера Steam: HLS там, где браузер его не умеет сам.
 *
 * Полноразмерного mp4 у Steam больше нет (проверено на живых карточках
 * 2026-07-31: appdetails.movies[].mp4 = null), остались потоковые дорожки.
 *
 * ПРОГРЕВ ЗАРАНЕЕ (требование Евгения 2026-07-31: «youtube работает
 * мгновенно, а у нового плеера пара секунд промедления»). Задержка
 * складывалась из трёх вещей на первом клике: скачать библиотеку, разобрать
 * манифест, набрать буфер. Всё это уезжает с критического пути — к моменту
 * нажатия плеер уже готов.
 *
 * ГРЕЕМ У БЛОКА, А НЕ ПРИ ОТКРЫТИИ КАРТОЧКИ (решение Евгения 2026-09-18).
 * Прогрев на загрузке стоил 1,3–1,9 МБ на КАЖДОМ просмотре мобильной
 * карточки, включая тех, кто до трейлера не долистал, — на платном
 * мобильном трафике. Теперь на телефоне прогрев стартует, когда кнопка
 * трейлера показалась на экране (IntersectionObserver): кто долистал —
 * получает мгновенный запуск, кто нет — не платит трафиком. Плеер,
 * который стоит на странице сам (десктоп), греется при загрузке, как
 * раньше: там трафик не узкое место, а мгновенность — требование.
 * Скрытые копии плеера (у них нет боксов) не греются вовсе. Библиотека
 * грузится в простое, буфер — первые секунды.
 *
 * 🔴 Гоча первого захода: нельзя ждать события play, чтобы подставить
 * источник. У <video> БЕЗ источника это событие не возникает вовсе —
 * плеер показывал постер и молчал.
 */
(() => {
  // Скрипт подключают и мобильная карточка, и десктопная секция трейлера:
  // обычный <script defer> с тем же адресом браузер выполнит ДВАЖДЫ, и
  // все слушатели ниже удвоились бы. Второй запуск — сразу выход.
  if (window.pzTrailerScriptIsLoaded) return;
  window.pzTrailerScriptIsLoaded = true;

  const LIB_ATTR = 'data-pz-hls-lib';
  const SRC_ATTR = 'data-pz-hls-src';
  const POSTER_ATTR = 'data-pz-poster';
  const PLAYER_SELECTOR = 'video.pz-trailer__video';
  // Селектор элемента, появление которого на экране запускает прогрев
  // (мобильный плеер живёт в закрытом окне — следим за кнопкой, что его
  // открывает). Нет атрибута — плеер стоит на странице сам (десктоп).
  const WARM_TRIGGER_ATTR = 'data-pz-warm-trigger';
  // Какая доля кнопки/плеера должна быть на экране, чтобы начать прогрев.
  // Без запаса «за экран» намеренно: на телефоне блок медиа стоит сразу
  // под кнопкой покупки, и запас включал прогрев при загрузке у всех
  // (замер 2026-09-18 на черновике: 15 запросов ролика до прокрутки).
  const WARM_VISIBLE_SHARE = 0.25;
  const NATIVE_HLS = 'application/vnd.apple.mpegurl';

  // Сколько секунд трейлера набирать заранее. Хватает, чтобы нажатие play
  // сработало без паузы, и не тянет весь ролик тем, кто его не смотрит.
  const WARM_BUFFER_SECONDS = 12;

  let libPromise = null;

  function whenIdle(run) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 300);
    }
  }

  function loadLibrary(url) {
    if (libPromise) return libPromise;
    libPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return libPromise;
  }

  async function warmViaLibrary(video, src) {
    try {
      await loadLibrary(video.getAttribute(LIB_ATTR));
      if (!window.Hls || !window.Hls.isSupported()) throw new Error('no hls');
      const player = new window.Hls({ maxBufferLength: WARM_BUFFER_SECONDS });
      player.loadSource(src);
      player.attachMedia(video);
    } catch (error) {
      // Библиотека не доехала — отдаём ссылку браузеру: часть движков
      // всё же откроет поток сама, и это лучше молчащей кнопки.
      video.src = src;
    }
  }

  function warm(video) {
    if (video.dataset.pzReady === '1') return;
    const src = video.getAttribute(SRC_ATTR);
    if (!src) return;
    video.dataset.pzReady = '1';

    // canPlayType отвечает 'maybe' у Safari и пустой строкой у Chrome.
    if (video.canPlayType(NATIVE_HLS)) {
      video.src = src;          // preload="metadata" сам подтянет начало
      return;
    }
    whenIdle(() => warmViaLibrary(video, src));
  }

  /* Постер — только плееру, который реально показан.
   *
   * Атрибут poster браузер качает сразу, даже у <video> в закрытом
   * диалоге или в скрытой секции старого стека. На мобильной карточке это
   * давало две лишние копии обложки (width 1280 и 1600), которые делили
   * канал с главной картинкой (замер 2026-09-18: главная картинка
   * появлялась через 8 с). Поэтому разметка кладёт адрес в data-pz-poster,
   * а ставим его здесь: у видимого плеера — сразу, у плеера в диалоге —
   * при открытии (событие dialog:open ниже). Нет боксов = не показан. */
  function showPoster(video) {
    if (video.getAttribute('poster')) return;
    if (!isShown(video)) return;
    // Уже скачанная картинка страницы (data-pz-poster-from — её селектор)
    // главнее собственного адреса: тот же файл из кэша, постер виден сразу,
    // а не чёрный прямоугольник, пока докачивается ещё одна копия обложки.
    const sourceSelector = video.dataset.pzPosterFrom;
    const source = sourceSelector ? document.querySelector(sourceSelector) : null;
    const poster = (source && source.currentSrc) || video.getAttribute(POSTER_ATTR);
    if (poster) video.setAttribute('poster', poster);
  }

  function isShown(element) {
    return element.getClientRects().length > 0;
  }

  /* Прогреть, когда триггер (кнопка трейлера) реально на экране.
   * Плеер без триггера стоит на странице сам — греем при загрузке, если
   * он показан. Скрытая копия (display:none, нет боксов) не греется.
   * Без IntersectionObserver — прогрев сразу, как было до 2026-09-18. */
  function warmWhenVisible(video) {
    if (video.dataset.pzReady === '1' || video.dataset.pzIsWarmObserved === '1') return;
    const triggerSelector = video.getAttribute(WARM_TRIGGER_ATTR);
    if (!triggerSelector) {
      if (isShown(video)) warm(video);
      return;
    }
    const trigger = document.querySelector(triggerSelector);
    if (!trigger) return;
    if (!('IntersectionObserver' in window)) {
      warm(video);
      return;
    }
    video.dataset.pzIsWarmObserved = '1';
    const observer = new IntersectionObserver((entries) => {
      // Браузер зовёт и на первом пикселе пересечения, не только на пороге:
      // долю проверяем сами. Скрытый элемент по спеке может дать долю 1 —
      // поэтому и проверка боксов.
      const isVisibleEnough = entries.some((entry) => entry.intersectionRatio >= WARM_VISIBLE_SHARE);
      if (!isVisibleEnough || !isShown(trigger)) return;
      observer.disconnect();
      warm(video);
    }, { threshold: WARM_VISIBLE_SHARE });
    observer.observe(trigger);
  }

  function init() {
    // Только плееры трейлера: у анимаций описания Steam тот же атрибут,
    // но постер им ставит свой наблюдатель — лишь в поле зрения.
    document.querySelectorAll(PLAYER_SELECTOR + '[' + POSTER_ATTR + ']').forEach(showPoster);
    document.querySelectorAll('video[' + SRC_ATTR + ']').forEach(warmWhenVisible);
  }

  // Открыли окно трейлера — покупатель уже нажал: постер и прогрев сразу,
  // без ожидания наблюдателя. Только плееры внутри открытого окна.
  function onDialogOpen(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.target.querySelectorAll(PLAYER_SELECTOR).forEach((video) => {
      showPoster(video);
      warm(video);
    });
  }

  /* Закрыли диалог — трейлер обязан замолчать.
   *
   * Штатный dialog-component темы просто прячет окно: <video> продолжает
   * играть, и покупатель слышит звук с невидимого экрана (замечание
   * Евгения 2026-07-31). У кадра YouTube та же беда, поэтому ему возвращаем
   * пустой src — заодно это восстанавливает ленивую загрузку: скрипт
   * карточки ставит src обратно при следующем открытии.
   *
   * Событие close НЕ всплывает, поэтому слушаем в фазе перехвата.
   */
  function silence(dialog) {
    dialog.querySelectorAll('video').forEach((video) => video.pause());
    dialog.querySelectorAll('iframe[src]').forEach((frame) => {
      if (!frame.dataset.pzTrailerSrc) frame.dataset.pzTrailerSrc = frame.src;
      frame.removeAttribute('src');
    });
  }

  document.addEventListener('close', (event) => {
    if (event.target instanceof HTMLElement) silence(event.target);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Событие темы называется 'dialog:open' (assets/dialog.js,
  // DialogOpenEvent) и НЕ всплывает — поэтому, как и close выше, слушаем
  // в фазе перехвата. Прежняя подписка на 'dialog:opened' не срабатывала
  // ни разу (замер 2026-09-18).
  document.addEventListener('dialog:open', onDialogOpen, true);
})();
